import i18n from 'i18next'
import * as Yup from 'yup'

const ValidationSchema = (
  _tlsValid: boolean,
  _dataPrivacyConsentAcceptance?: boolean
) => {
  return Yup.object().shape({
    termsAgreeCheckAgree: Yup.boolean()
      .required(i18n.t('validation:required'))
      .oneOf([true], i18n.t('validation:required')),
  })
}

export default ValidationSchema
